import React, { useEffect, useState } from "react";
import { FaPencilAlt, FaChevronRight, FaSignOutAlt, FaEye, FaSave, FaTimes, FaEdit } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import IconAlert from "../../components/elements/IconAlert";
import PreviewPDF from '../../components/modal/PreviewPDF'
import { useNavigate } from "react-router-dom";
import { getPrefixes, logOut, usersResource } from "../../helpers/configRoutes/backend_helper";
import CustomInput from "../../components/form/CustomInput";
import { useFormik } from "formik"
import CustomSelect from "../../components/form/CustomSelect";
import FileInput from "../../components/form/FileInput";
import * as Yup from "yup";
import { validatePhones } from "../../helpers/forms/Validation";
import { showFormErrors } from "../../helpers/showFormErrors";

const Profile = () => {
    const navigate = useNavigate()
    const user = useSelector((state) => state.Login.user)
    const [modal, setModal] = useState({ show: false, url: '' })

    // Función de cierre de sesión (puedes adaptarla según tu lógica de autenticación)
    const handleLogout = async () => {
        // Llamar a la función de cierre de sesión
        const response = await logOut();
        // Eliminar los datos del localStorage
        localStorage.removeItem('isAuth');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Redirigir al usuario a la página de inicio de sesión o a otra página
        // Puedes utilizar history.push("/login") si usas react-router
        navigate('/login'); // O usa una redirección
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center p-4">
            {/* Sección de Encabezado */}
            <h1 className="text-lg font-semibold text-gray-800 mb-6">Profile</h1>

            {/* Imagen de Perfil */}
            <div className="relative mb-4">
                <div className="w-24 h-24 rounded-full bg-mts-primary flex items-center justify-center">
                    {user.imageProfile ?
                        <img
                            src={user.imageProfile} // Reemplaza con la URL o variable de tu imagen
                            alt="User Profile"
                            className="w-24 h-24 rounded-full object-cover border-2 border-white shadow-md"
                        />
                        :
                        <span className="text-4xl text-mts-primary-hover">👤</span>
                    }
                </div>
            </div>

            {/* Nombre y Correo */}
            <div className="text-center mb-6">
                <h2 className="text-lg font-bold text-gray-800">{user.name}</h2>
                <p className="text-gray-500 text-sm">{user.email}</p>
            </div>


            {/* Opciones de Perfil */}
            <div className="w-full max-w-md bg-white rounded-lg shadow">
                <div
                    className="flex flex-col justify-between items-start py-4 px-6 border-b last:border-b-0 hover:bg-gray-100 cursor-pointer"
                >

                    <div className="flex justify-between items-center gap-4 mt-4 w-full">
                        {/* Nombre del usuario */}
                        <div className="flex justify-start w-3/4">
                            <span className="text-gray-700 font-medium">{user.first_name} {user.last_name}</span>
                        </div>
                    </div>
                </div>

                <div
                    className="justify-between items-center py-4 px-6 border-b last:border-b-0 hover:bg-gray-100 cursor-pointer"
                >

                    <div className="flex justify-between items-center gap-4 mt-4 w-full">
                        {/* Nombre del usuario */}
                        <div className="flex justify-start w-3/4">
                            <span className="text-gray-700 font-medium">Phone: {user.phone_prefix}{user.phone}</span>
                        </div>
                    </div>

                </div>
                <div
                    className=" justify-between items-center py-4 px-6 border-b last:border-b-0 hover:bg-gray-100 cursor-pointer"
                >

                    <div className="flex justify-between items-center gap-4 mt-4 w-full">
                        <span className="text-gray-700 font-medium">Driver license:
                            <p>Expiration {user.license_expiration}</p>
                            <p>{user.license_expiration_days} days remaining {' '}
                                <IconAlert days={user.license_expiration_days} textAlert={'Your driver´s license is about to expire'} />
                            </p>
                        </span>
                        <FaEye className="text-gray-400 cursor-pointer" onClick={() => setModal({ ...modal, show: true, url: user.driver_license })} />
                    </div>
                </div>
                <div
                    className=" justify-between items-center py-4 px-6 border-b last:border-b-0 hover:bg-gray-100 cursor-pointer"
                >
                    <div className="flex justify-between items-center gap-4 mt-4 w-full">
                        <span className="text-gray-700 font-medium">DOT physical:
                            <p>Expiration {user.dot_physical_expiration}</p>
                            <p>{user.dot_physical_expiration_days} days remaining {' '}
                                <IconAlert days={user.dot_physical_expiration_days} textAlert={'Your driver´s license is about to expire'} />
                            </p>
                        </span>
                        <FaEye className="text-gray-400 cursor-pointer" onClick={() => setModal({ ...modal, show: true, url: user.dot_physical_certificate })} />
                    </div>
                </div>
                <div
                    className="flex justify-between items-center py-4 px-6 border-b last:border-b-0 hover:bg-gray-100 cursor-pointer"
                >
                    <span className="text-gray-700 font-medium">Truck: {user.truk_number || 'Not Asigned'}</span>
                </div>
                <div
                    className="flex justify-between items-center py-4 px-6 border-b last:border-b-0 hover:bg-gray-100 cursor-pointer"
                >
                    <span className="text-gray-700 font-medium">Registered Date: {user.created_at}</span>
                </div>
                <div
                    className="flex justify-between items-center py-4 px-6 border-b last:border-b-0 hover:bg-gray-100 cursor-pointer" onClick={handleLogout}
                >
                    <span className="text-gray-700 font-medium">Log Out</span>
                    <FaSignOutAlt className="text-gray-400" />
                </div>
            </div>
            <PreviewPDF modal={modal} setModal={setModal} />
            <div className="fixed bottom-20 right-6 flex flex-col items-end gap-3">
                <button
                    className="w-14 h-14 bg-mts-warning text-white rounded-full flex items-center justify-center shadow-lg transition-transform transform hover:scale-105"
                    onClick={() => navigate('/edit-profile')}
                >
                    <FaEdit size={20} />
                </button>
            </div>
        </div>
    );
};

export default Profile;
